export default "__VITE_ASSET__S857gn7B__"